import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { GridsterModule } from './../gridster/lib/gridster.module';
import { RADashboardControl } from './ra-dashboard-control/ra.dashboard.control';
import { RAWidgetContainer } from './ra-widget-container/ra.widget.container.component';
//import { RAWidgetConfigContainer } from './ra-widget-config-container/ra.widget.config.container.component';

@NgModule({
  declarations: [    
    RADashboardControl,
    RAWidgetContainer,
   // RAWidgetConfigContainer
  ],
  imports: [
    BrowserModule,
    GridsterModule
  ],
  providers: [], 
  bootstrap: [RADashboardControl]
})
export class AppModule { }
